module.exports = __webpack_public_path__ + "img/dypx.523c6203.png";